import { Meta } from '@master/model/common/Meta'

export default class SpouseDetailsMeta extends Meta {
  name = ''
  occupation = ''
  dateOfBirth: number = undefined
  nationality = ''
  nationalitySpecified = ''
  race = ''
  idDocType = ''
  idNumber = ''
  contactNumber = ''
}
